import React from 'react';
import { Flex } from '@chakra-ui/react';
import { IntegrityChecksSection } from '../IntegrityChecksSection';

interface IntegrityChecksTabProps {
  journalId: string;
}

const IntegrityChecksTab: React.FC<IntegrityChecksTabProps> = ({
  journalId
}) => {
  return (
    <Flex flexDirection="column" gap={4} width="100%">
      <IntegrityChecksSection journalId={journalId} />
    </Flex>
  );
};

export default React.memo(IntegrityChecksTab);
